import React, { useCallback, useMemo, useReducer, useRef } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';

import { COLORS } from '../../../Constant/COLORS';

import FormContext from './FormContext';

import EmailVerification from './FormSteps/EmailVerification';
import ContactInformation from './FormSteps/ContactInformation';
import PersonalInformation from './FormSteps/PersonalInformation';
import MobileNumberVerification from './FormSteps/MobileNumberVerification';

import useMultiStepForm from '../../../Hooks/useMultiStepForm';

import { TypoPoppins } from '../../Typo';

function Signup({ open, onClose, openLoginModal }) {
  const {
    CurrentStep,
    nextStep,
    previousStep,
    isFirstStep,
    stepTo,
    currentStep,
    totalSteps,
  } = useMultiStepForm([
    ContactInformation,
    MobileNumberVerification,
    EmailVerification,
    PersonalInformation,
  ]);

  const [inputs, updateInputs] = useReducer(
    (state, inputs) => ({ ...state, ...inputs }),
    { mobileNumber: '', email: '' }
  );

  const codeRefId = useRef({
    mobileNumber: null,
    email: null,
  }).current;

  const closeModal = useCallback(() => {
    onClose();
    stepTo(1);
  }, [onClose, stepTo]);

  const formContextValue = useMemo(
    () => ({
      inputs,
      nextStep,
      updateInputs,
      codeRefId,
      openLoginModal,
      closeModal,
    }),
    [closeModal, codeRefId, inputs, nextStep, openLoginModal]
  );

  return (
    <Dialog
      open={open}
      onClose={closeModal}
      PaperProps={{ sx: { borderRadius: { xs: '16px', md: '20px' } } }}
    >
      <DialogContent>
        <FormContext.Provider value={formContextValue}>
          <Box sx={{ pt: 2 }}>
            {!isFirstStep && (
              <Button variant='text' onClick={previousStep}>
                <TypoPoppins color={COLORS.black2}>Back</TypoPoppins>
              </Button>
            )}

            <Typography variant='h4' textAlign='center'>
              Sign up to Evento
            </Typography>

            <Box maxWidth={320} mx='auto' mt={2} mb={1}>
              <Stack direction='row' justifyContent='space-between' mb={0.75}>
                <Typography variant='overline' color={COLORS.teal}>
                  Step {currentStep} of {totalSteps}
                </Typography>
              </Stack>
              <Box sx={{ height: 5, borderRadius: 999, bgcolor: COLORS.surfaceAlt, overflow: 'hidden' }}>
                <Box
                  sx={{
                    height: '100%',
                    width: `${(currentStep / totalSteps) * 100}%`,
                    borderRadius: 999,
                    background: `linear-gradient(90deg, ${COLORS.teal}, ${COLORS.tealDark})`,
                    transition: 'width .45s cubic-bezier(0.22,1,0.36,1)',
                  }}
                />
              </Box>
            </Box>

            <CurrentStep />
          </Box>
        </FormContext.Provider>
      </DialogContent>
    </Dialog>
  );
}

export default Signup;
